<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #CoordenadasClientes
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Aprobación de Coordenadas de Clientes

    v-dialog(v-model='dialog', persistent max-width='700px')
      v-container(style='background-color:white !important;max-width: 700px;')
        v-card-title.justify-center
          span.headline Detalle de Solicitud
        div(style="margin-top: 20px;")
          v-flex(xs12, sm12, md12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12, md8)
                v-form

                  v-text-field(outline readonly v-model="form.cliente"
                    prepend-inner-icon="person" label="Cliente:")

                  v-text-field(outline readonly v-model="form.vendedor"
                    prepend-inner-icon="supervised_user_circle" label="Vendedor:")

                  v-text-field(outline readonly v-model="form.latitud"
                    prepend-inner-icon="place" label="Latitud:")

                  v-text-field(outline readonly v-model="form.longitud"
                    prepend-inner-icon="place" label="Longitud:")

                  div(v-if="form.latitud && form.longitud" style="height:300px;margin-bottom:20px;border-radius:5px;overflow:hidden;")
                    l-map(ref="map" :zoom="15" :center="[form.latitud, form.longitud]" style="height:100%;width:100%;")
                      l-tile-layer(:url="tileUrl")
                      l-marker(:lat-lng="[form.latitud, form.longitud]")

                  v-textarea(outline v-model="form.observacion"
                    prepend-inner-icon="comment" label="Observación:"
                    :disabled="form.estatus === 'Aprobado'")

                  v-layout(justify-center row wrap style="margin-top:10px;gap:10px;")
                    v-btn(v-if="form.estatus === 'Pendiente'" color="green" dark @click="aprobar()") Aprobar
                    v-btn(v-if="form.estatus === 'Pendiente'" color="red" dark @click="rechazar()") Rechazar
                    v-btn(color="grey" dark @click="close()") Cerrar

    v-layout(align-start='', justify-start='', row='', fill-height='', style="margin-top:10px;")
      v-flex(xs12, md12, sm12)
        v-card
          v-card-title
            span.title Lista de Solicitudes
            v-spacer
            v-select(
              v-model="filtroEstatus"
              :items="['Todos', 'Pendiente', 'Aprobado', 'Rechazado']"
              label="Filtrar por estatus"
              style="max-width:200px;"
              @change="cargarSolicitudes"
            )
          v-data-table(
            :headers="headers"
            :items="solicitudes"
            :rows-per-page-items="[10, 25, 50]"
          )
            template(v-slot:items="props")
              td {{ props.item.cliente }}
              td {{ props.item.vendedor }}
              td {{ formatDate(props.item.fechaCreacion) }}
              td
                v-chip(:color="getStatusColor(props.item.estatus)" dark small)
                  | {{ props.item.estatus | capitalize }}
              td
                v-btn(icon @click="verDetalles(props.item)")
                  v-icon remove_red_eye
</template>

<script>
import Api from "@/services/methods";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export default {
  name: "CoordenadasClientes",
  components: { LMap, LTileLayer, LMarker },
  filters: {
    capitalize(val) {
      if (!val) return "";
      return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    }
  },
  data() {
    return {
      dialog: false,
      solicitudes: [],
      filtroEstatus: "Todos",
      tileUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      form: {
        _id: "",
        cliente: "",
        vendedor: "",
        latitud: null,
        longitud: null,
        estatus: "",
        observacion: ""
      },
      cre: "",
      mod: "",
      elm: "",
      headers: [
        { text: "Cliente", value: "cliente" },
        { text: "Vendedor", value: "vendedor" },
        { text: "Fecha", value: "fechaCreacion" },
        { text: "Estado", value: "estatus" },
        { text: "Acciones", value: "acciones", sortable: false }
      ]
    };
  },
  watch: {
    dialog(newVal) {
      if (newVal && this.form.latitud && this.form.longitud) {
        setTimeout(() => {
          if (this.$refs.map) this.$refs.map.mapObject.invalidateSize();
        }, 100);
      }
    }
  },
  mounted() {
    this.verificacion();
    this.cargarSolicitudes();
  },
  methods: {
    verificacion() {
      const permisos = this.$store.state.adminelgocho.permisos || [];
      for (let i = 0; i < permisos.length; i++) {
        if (permisos[i].ruta === "CoordenadasClientes") {
          for (let j = 0; j < permisos[i].accion.length; j++) {
            if (permisos[i].accion[j] === "Crear") this.cre = "yes";
            if (permisos[i].accion[j] === "Modificar") this.mod = "yes";
            if (permisos[i].accion[j] === "Eliminar") this.elm = "yes";
          }
        }
      }
    },
    async cargarSolicitudes() {
      try {
        const params =
          this.filtroEstatus !== "Todos"
            ? `?estatus=${this.filtroEstatus}`
            : "";
        const res = await Api.get(`clienteCoordenadas${params}`);
        this.solicitudes = res.data;
      } catch (e) {
        // Error cargando solicitudes
      }
    },
    verDetalles(item) {
      this.form = {
        _id: item._id,
        cliente: item.cliente,
        vendedor: item.vendedor,
        latitud: item.latitud,
        longitud: item.longitud,
        estatus: item.estatus,
        observacion: item.observacion || ""
      };
      this.dialog = true;
    },
    async aprobar() {
      try {
        await Api.post(`clienteCoordenadas/${this.form._id}/aprobar`);
        this.close();
        this.cargarSolicitudes();
      } catch (e) {
        var msg =
          (e.response && e.response.data && e.response.data.error) || e.message;
        alert("Error al aprobar: " + msg);
      }
    },
    async rechazar() {
      if (!this.form.observacion || !this.form.observacion.trim()) {
        alert("Debe ingresar una observación para rechazar.");
        return;
      }
      try {
        await Api.post(`clienteCoordenadas/${this.form._id}/rechazar`, {
          observacion: this.form.observacion
        });
        this.close();
        this.cargarSolicitudes();
      } catch (e) {
        var msg =
          (e.response && e.response.data && e.response.data.error) || e.message;
        alert("Error al rechazar: " + msg);
      }
    },
    close() {
      this.dialog = false;
      this.form = {
        _id: "",
        cliente: "",
        vendedor: "",
        latitud: null,
        longitud: null,
        estatus: "",
        observacion: ""
      };
    },
    getStatusColor(estatus) {
      if (estatus === "Pendiente") return "orange";
      if (estatus === "Aprobado") return "green";
      if (estatus === "Rechazado") return "red";
      return "grey";
    },
    formatDate(fecha) {
      if (!fecha) return "";
      return this.$moment(fecha).format("DD/MM/YYYY HH:mm");
    }
  }
};
</script>
